import {Modal, ModalBody, ModalContent, ModalHeader} from '@heroui/react';
import {useDictionary} from '@adamlip/okeoke.client';
import ActivatePoints from 'components/_VIP/ActivatePoints';

export default function ActivatePointsModal({isOpen, setIsOpen}) {
	const {getValue} = useDictionary();

	return (
		<Modal
			isOpen={isOpen}
			onOpenChange={() => setIsOpen(!isOpen)}
			size='2xl'
			scrollBehavior='inside'
			classNames={{
				closeButton: 'z-50 bg-primary text-primary-foreground',
			}}>
			<ModalContent>
				{(onClose) => (
					<>
						<ModalHeader>
							<div className='w-full text-center'>{getValue('app_v2_activate_points_title')}</div>
						</ModalHeader>
						<ModalBody>
							<ActivatePoints onSuccess={() => setIsOpen(false)} />
						</ModalBody>
					</>
				)}
			</ModalContent>
		</Modal>
	);
}
